import { SettingService } from './setting.service';
import { UploadService } from './upload.service';
import { CpanelService } from './cpanel.service';
import { Injectable } from '@angular/core';
import { UsersService } from './user.service';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class VayvayService {
  constructor(
    private userservice: UsersService,
    private cpanelService: CpanelService,
    private langService: LanguageService,
    private upload: UploadService,
    private settings: SettingService
  ) {}

  Services() {
    return {
      UserService: this.userservice,
      LanguageService: this.langService,
      CpanelService: this.cpanelService,
      Upload: this.upload,
      Settings: this.settings,
    };
  }
}
